export const GTM_EVENTS = {
  COMPANY_DETAILS_LOADED: "company_details_loaded",
  PAGE_VIEW: "page_view",
  CHECKOUT_PAGE_VIEW: "checkout_page_view",
  CHECKOUT_ADDON_CHANGED: "checkout_addon_changed",
  CART_CHECKOUT_PAGE_VIEW: "cart_checkout_page_view",
  CART_CHECKOUT_ADDRESS_SELECTED: "cart_checkout_address_selected",
  CART_CHECKOUT_PAYMENT_METHOD_CHANGED: "cart_checkout_payment_method_changed",
  CART_CHECKOUT_ADD_NEW_ADDRESS_CLICKED:
    "cart_checkout_add_new_address_clicked",
  CART_COUPON_APPLY_ATTEMPT: "cart_coupon_apply_attempt",
  CART_COUPON_APPLY_SUCCESS: "cart_coupon_apply_success",
  CART_COUPON_APPLY_FAIL: "cart_coupon_apply_fail",
  ADD_TO_CART: "add_to_cart",
  BEGIN_CHECKOUT: "begin_checkout",
  PURCHASE: "purchase",
  LOGIN_SUCCESS: "login_success",
  SIGNUP_SUCCESS: "signup_success",
  CONTACT_FORM_SUBMITTED: "contact_form_submitted",
  CONTACT_FORM_ERROR: "contact_form_error",
  ORDER_CONFIRMED: "order_confirmed",
  MAGIC_PAGE_VIEW: "magic_page_view",
  QR_MAGIC_PAGE_VIEW: "qr_magic_page_view",
  AR_MAGIC_PAGE_VIEW: "ar_magic_page_view",
};

export const gtmEventPayload = (eventName, payload = {}) => ({
  event: eventName,
  ...payload,
});
